import { CodeTypeModel } from "@fs/models/code-type.model";

export class ContactInfoModel{
    public FirstName:string;
    public ID:string;
    public LastName:string;
    public IsPrimary:boolean;
    public IsDirty:boolean;
    public PhoneNumbers:PhoneNumber[];
    public Emails:Email[];
    constructor(){
      this.FirstName = "";
      this.ID = "";
      this.LastName = "";
      this.IsPrimary = false;
      this.PhoneNumbers =[];
      this.Emails =[];
    }
}

export class PhoneNumber{
  public PhoneNumber:string;
  public Description:string;
  public ID:string;
  public IsDirty:boolean;
  public IsUsedForSMS: boolean;
  public Type: any;
  constructor(){
    this.PhoneNumber = "";
    this.ID = "";
    this.Description = "";
    this.IsDirty = false;
    this.IsUsedForSMS =false;
    this.Type =[];
  }
}
export class Email{
  public EmailAddress:string;
  public IsDirty:boolean;
  public ID:string;
  public Description:string;
  public IsUsedForEmail: boolean;
  constructor(){
    this.EmailAddress = "";
    this.ID = "";
    this.Description = "";
    this.IsDirty = false;
  }
}